import React, { useState } from "react";
import { HeartHandshake, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const LANGS = ["", "sk", "en", "cs", "de", "pl", "fr"];

export default function AddSupporterBlock() {
  const [email, setEmail] = useState("");
  const [lang, setLang] = useState("");
  const [sendThanks, setSendThanks] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/admin/supporters/add", { email: email.trim(), send_thanks: sendThanks, lang: lang || null });
      toast.success(`${r.data.name} pridaný do Siene slávy${r.data.thanks_sent ? " · ďakovný e‑mail odoslaný" : ""}`);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Nepodarilo sa pridať podporovateľa");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="add-supporter-block"
          className="border border-gold-700/40 bg-gold-500/5 p-3 flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2 text-xs text-zinc-300 flex-1 min-w-[240px]">
        <HeartHandshake className="w-4 h-4 text-gold-400" />
        <div>
          <div className="font-display font-bold text-gold-400">Pridať podporovateľa centra</div>
          <div className="text-[10px] text-zinc-500 mt-0.5">Pre staršie dary: zobrazí meno v Sieni slávy a pošle ďakovný e‑mail s listom (bez faktúry).</div>
        </div>
      </div>
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email darcu"
             data-testid="add-supporter-email" className="wb-input px-3 py-1.5 text-xs w-56" />
      <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid="add-supporter-lang"
              className="wb-input px-2 py-1.5 text-xs">
        {LANGS.map((l) => <option key={l} value={l}>{l ? l.toUpperCase() : "jazyk profilu"}</option>)}
      </select>
      <label className="flex items-center gap-1.5 text-[11px] text-zinc-300">
        <input type="checkbox" checked={sendThanks} onChange={(e) => setSendThanks(e.target.checked)}
               data-testid="add-supporter-send-thanks" className="accent-yellow-500" /> poslať poďakovanie
      </label>
      <button type="submit" disabled={busy} data-testid="add-supporter-submit"
              className="wb-btn-primary px-3 py-1.5 text-xs inline-flex items-center gap-1 disabled:opacity-50">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <HeartHandshake className="w-3.5 h-3.5" />} Pridať
      </button>
    </form>
  );
}
